module.exports = __webpack_public_path__ + "static/media/home.1c83fc7e.svg";